import { ItemChartModel } from "../global/item-chart.model";

export class ElectronicInvoiceInterfaceChartModel {
  totalSendDian: number = 0;
  statesSendDian: ItemChartModel[] = [];
  totalSendMail: number = 0;
  statesSendMail: ItemChartModel[] = [];
}
